const actionTypes = {
  MENU_TRIGGER_UP: 0,
  MENU_ITEM_UP: 1,
  MENU_TRIGGER_DOWN: 2,
  MENU_ITEM_DOWN: 3,
  MENU_ITEM_ESCAPE: 4,
  MENU_ITEM_TAB: 5,
  MENU_ITEM_ENTER: 6,
  MENU_ITEM_LEAVE: 7,
  MENU_ITEM_SPACE: 8,
  MENU_ITEM_CLICK: 9,
  MENU_ITEM_HOVER: 10,
  MENU_TRIGGER_ENTER: 11,
  MENU_TRIGGER_SPACE: 12,
  MENU_TRIGGER_CLICK: 13,
  MENU_TRIGGER_TAB: 14,
  MENU_TRIGGER_ESCAPE: 15,
  BACKDROP_CLICK: 16
};
export {
  actionTypes
};
